import { getBackendUrl } from '../utils/getBackendUrl';
import { getApi } from './httpCommon';

const BACKEND = getBackendUrl() + '/formValues';
const api = getApi(BACKEND);

export const getNaicsList = async () => {
  return await api.get<Naics[]>('/naics');
};
